import { Box, Button } from "@chakra-ui/react";
import React, { useContext } from "react";
import "../Assets/Styles/Ensambles.css"
import useFetch from "../Hooks/useFetch";
import useRender from "../Hooks/useRender";
import Footer from "../Footer";
import useScrollToTop from "../Hooks/useScrollToTop";
import useCart from "../Hooks/useCart";
import { ThemeContext } from "../Context/ThemeContext";

function Ensambles(){

    const {builds} = useFetch()
    const {renderComponents} = useRender()
    const { addCart, loading, handleButtonCart } = useCart();
    const { theme } = useContext(ThemeContext);
    useScrollToTop();

    return (
        <>
        <Box className="builds-section-container">
            <Box className="builds-gamer-container">
                {builds.map((build)=>{
                    const isEven = build.id % 2 === 0;
                return(
                    <React.Fragment key={build.code}>
                        {isEven?(
                            <div className="build-gamer-container">
                                <div className="text-gamer-build-container">
                                    <h1>{build.name}</h1>
                                    <p>A partir de:</p>
                                    <strong>$ {parseFloat(build.price).toFixed(2)}</strong>
                                    <div className="render-components-container">
                                        {renderComponents(build)}
                                    </div>
                                    {addCart.some((arr) => arr.code === build.code) ? (
                                        <Button
                                            bg={theme.backgroundColor}
                                            color={theme.highlightColor}
                                            isDisabled
                                            className="add-to-cart-btn"
                                        >
                                            Articulo añadido
                                        </Button>
                                    ) : (
                                        <Button
                                            bg={theme.backgroundColor}
                                            color={theme.color}
                                            isLoading={build.code === loading}
                                            onClick={() => handleButtonCart(build)}
                                            sx={{ _hover: { bg: theme.highlightColor, color: theme.backgroundColor } }}
                                            className="add-to-cart-btn"
                                        >
                                            Añadir al carrito <i className="fa-solid fa-cart-shopping"></i>
                                        </Button>
                                    )}
                                </div>
                                <div className="img-gamer-build-container">
                                    <img src={build.img_url} alt="IMAGEN ENSAMBLE" width="100%"/>
                                </div>
                            </div>
                        ):(
                            <div className="build-gamer-container" key={build.id}>
                                <div className="img-gamer-build-container">
                                    <img src={build.img_url} alt="IMAGEN ENSAMBLE" width="100%"/>
                                </div>
                                <div className="text-gamer-build-container">
                                    <h1>{build.name}</h1>
                                    <p>A partir de:</p>
                                    <strong>$ {parseFloat(build.price).toFixed(2)}</strong>
                                    <div className="render-components-container">
                                        {renderComponents(build)}
                                    </div>
                                    {addCart.some((arr) => arr.code === build.code) ? (
                                        <Button
                                            bg={theme.backgroundColor}
                                            color={theme.highlightColor}
                                            isDisabled
                                            className="add-to-cart-btn"
                                        >
                                            Articulo añadido
                                        </Button>
                                    ) : (
                                        <Button
                                            bg={theme.backgroundColor}
                                            color={theme.color}
                                            isLoading={build.code === loading}
                                            onClick={() => handleButtonCart(build)}
                                            sx={{ _hover: { bg: theme.highlightColor, color: theme.backgroundColor } }}
                                            className="add-to-cart-btn"
                                        >
                                            Añadir al carrito <i className="fa-solid fa-cart-shopping"></i>
                                        </Button>
                                    )}
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )})}
            </Box>
        </Box>
        <Footer/>
        </>
    )
}
export default Ensambles